import { connect } from 'react-redux'
import { compose } from 'redux'
import { reduxForm } from 'redux-form'
import { withStyles } from '@material-ui/core'

import { globalActions } from 'reduxModules/actions/GlobalActions'

import { CreateDriverFormBase } from './CreateDriverForm'

import { styles } from './styles'

const mapDispatchToProps = {
  onSubmit: globalActions.createDriver
}

const enhance = compose(
  connect(null, mapDispatchToProps),
  reduxForm({
    form: 'createDriver'
  }),
  withStyles(styles)
)

export const CreateDriverForm = enhance(CreateDriverFormBase)



// WEBPACK FOOTER //
// ./src/components/Drivers/components/CreateDriverForm/index.js